export class ResponseData {
    threadid: number;
    data: Uint32Array;
}


/** WEBPACK FOOTER **
 ** ./src/scripts/fractals/responsedata.ts
 **/